export default {
  namespaced: true,
  planning: {
    title: 'Planificación | Planificación',
    activity_type: 'Tipo de actividad programada',
    business_division: 'División del Negocio',
    federal_entity: 'Entidad Federativa',
    rems: 'REMS',
    property_name: 'Nombre del Inmueble',
    property_type: 'Tipo Inmueble',
    property_types_in_selection: 'Tipos de inmueble en la selección',
    start_date: 'Fecha Inicio',
    end_date: 'Fecha Fin',
    start_programming: 'Iniciar programación',
    start_programming_modal_title: 'Iniciar programación',
    start_programming_modal_message: 'El formulario de programación se implementará aquí.',
    activity_type_to_schedule: 'Tipo de Actividad a Programar',
    form_templates: 'Plantillas de formulario',
    form_templates_placeholder: 'Seleccione una o más plantillas…',
    evaluacion_riesgo: 'Evaluación de riesgo',
    ejercicio_operativo: 'Ejercicio operativo',
    simulacro: 'Simulacro',
    auto_evaluacion_seguridad: 'Auto evaluación de seguridad',
    selected_units: 'Unidades seleccionadas',
    assigned_to: 'Asignado A',
    no_units_selected: 'Seleccione inmuebles arriba para agregarlos a la tabla.',
    units_label: 'Inmuebles',
    last_sra_date: 'Fecha de último SRA',
    residual_risk_level: 'Nivel de Riesgo Residual',
    status: 'Estado',
    planning_id: 'ID de planificación',
    list_col_assigned_to: 'Asignado a',
    list_col_in_review_by: 'En revisión por',
    list_col_accepted_cancelled: 'Aprobado / rechazado por',
    list_status_by: 'Por {name}',
    last_status_change: 'Último cambio de estado',
    status_draft: 'En progreso',
    status_review: 'En revisión',
    status_additional: 'Segunda aprobación',
    status_approved: 'Aprobado',
    status_rejected: 'Rechazado',
    status_released: 'Liberado',
    send_to_review: 'Mandar a revisión',
    send_to_approval: 'Mandar a aprobación',
    approve: 'Aprobar',
    reject: 'Rechazar',
    reject_comment: 'Comentario de rechazo',
    reject_comment_placeholder: 'Indique el motivo del rechazo (obligatorio)',
    send_programming: 'Liberar programación',
    target_date: 'Fecha objetivo',
    select_reviewer: 'Seleccione revisor',
    select_approver: 'Seleccione aprobador',
    send_second_approval: 'Enviar a segunda aprobación',
    accept_programming: 'Aceptar programación',
    download_planning: 'Descargar planeación',
    year: 'Año',
    fecha_inicio: 'Fecha inicio',
    fecha_fin: 'Fecha fin',
    user: 'Usuario',
    comment: 'Comentario',
    item_comment_prefix: 'Comentario',
    add_comment: 'Agregar comentario',
    comment_placeholder: 'Escriba un comentario',
    add_extra_units: 'Agregar inmuebles extras',
    add_extra_units_placeholder: 'Buscar y seleccionar inmuebles extras...',
    status_change_history_title: 'Historial de comentarios por cambio de estado',
    status_change_transition: 'De {from} a {to}',
    toast_planning_title: 'Planificación',
    toast_planning_id_line: 'Id de planificación ID: {id}',
    exit: 'Salir',
    scheduled_programming_notification: 'Tienes planificación programada',
  },
}
